export const SET_IMAGE_UPLOADING = "SET_IMAGE_UPLOADING";